'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _analytics = require('./analytics');

Object.defineProperty(exports, 'GENERIC_ERROR_FIELD_IDENTIFIER', {
  enumerable: true,
  get: function get() {
    return _analytics.GENERIC_ERROR_FIELD_IDENTIFIER;
  }
});
Object.defineProperty(exports, 'MESSAGE_TRACKING_QD_OPEN', {
  enumerable: true,
  get: function get() {
    return _analytics.MESSAGE_TRACKING_QD_OPEN;
  }
});
Object.defineProperty(exports, 'MESSAGE_TRACKING_QD_START', {
  enumerable: true,
  get: function get() {
    return _analytics.MESSAGE_TRACKING_QD_START;
  }
});
Object.defineProperty(exports, 'MESSAGE_TRACKING_QD_SUCCESSFUL', {
  enumerable: true,
  get: function get() {
    return _analytics.MESSAGE_TRACKING_QD_SUCCESSFUL;
  }
});
Object.defineProperty(exports, 'MESSAGE_TRACKING_QD_UNSUCCESSFUL', {
  enumerable: true,
  get: function get() {
    return _analytics.MESSAGE_TRACKING_QD_UNSUCCESSFUL;
  }
});